import type { TSelectedDetail } from '../../Types/MasterDetailTypes';

// Värde för id som inte ska användas.
export const NO_ID_AVAILABLE = 'NO_ID_AVAILABLE';

// Tillfällight id för nya poster
export const NewId = 'ny';

/**Hämtar id från selected detail*/
export const selectedId = (selectedDetail?: TSelectedDetail): string | null =>
  selectedDetail == null ? null : definedSelectedId(selectedDetail);

/**Samma som selectedId, men utan null i både in och utdata */
export const definedSelectedId = (
  selectedDetail: NonNullable<TSelectedDetail>
): string =>
  typeof selectedDetail === 'string' ? selectedDetail : selectedDetail.id;

//** nextId om det finns en sådan i selectedDetail. Alltid en sträng för att kunna användas som parameter i en query, men NO_ID_AVAILABLE måste kombineras med skip  */
export const nextIdParam = (selectedDetail?: TSelectedDetail): string =>
  selectedDetail == null || typeof selectedDetail === 'string'
    ? NO_ID_AVAILABLE
    : selectedDetail.nextId ?? NO_ID_AVAILABLE;

//** nextId om det finns en sådan i selectedDetail. Alltid en sträng för att kunna användas som parameter i en query, men NO_ID_AVAILABLE måste kombineras med skip  */
export const prevIdParam = (selectedDetail?: TSelectedDetail): string =>
  selectedDetail == null || typeof selectedDetail === 'string'
    ? NO_ID_AVAILABLE
    : selectedDetail.prevId ?? NO_ID_AVAILABLE;
